"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurfaceBasedTrackingEvents = void 0;
const trackingEventConstants_1 = require("./trackingEventConstants");
// READ THIS FIRST BEFORE ADDING THINGS HERE!!!
// We are capped by how many events we can have in Amplitude...so we want to
// keep this list short!
// Additonally its easier to browse these events in analytics tools
// if their are organized by surface or object type and NOT by action/feature/etc
exports.SurfaceBasedTrackingEvents = {
    // SLOW DOWN BEFORE YOU ADD STUFF HERE...THINK HARD! DOES IT REALLY, REALLY BELONG HERE?
    // Main Surfaces
    editor: "editor",
    schematicEditor: "schematic_editor",
    pcbEditor: "pcb_editor",
    siteSearch: "site_search",
    docs: "doc",
    // Sub surfaces
    onboardingUx: "onboardingUX",
    snackbar: "snackbar",
    newProjectDialog: trackingEventConstants_1.trackingEventNewProjectDialog,
    projectTemplate: "ProjectTemplate",
    markdown: "markdown",
    accountMenu: "account_menu",
    // Payments
    showPaywall: "show_paywall",
    // Editor Sub surfaces
    partSearch: "part_search",
    partPublishing: "part_publishing",
    permissionDialog: "permission_dialog",
    shortcutViewer: "shortcut_viewer",
    fileStorage: "file_storage",
    toolbarNodeEdit: "toolbar_node_edit",
    componentLibraryRefinement: "component_library_refinement",
    changeHistory: "change_history",
    designRuleCheck: "design_rule_check",
    export: "export",
    exportManufacturingFilesDialog: "export_manufacturing_files_dialog",
    // Profile sub surfaces
    profileDocumentSearch: "profile_document_search",
    // Copilot
    copilot: trackingEventConstants_1.trackingEventCopilot,
    copilotCredits: trackingEventConstants_1.trackingEventCopilotCredits,
    deeppcbReview: "deeppcb_review_completed",
    deeppcbPreflightAnomaly: "deeppcb_preflight_anomaly",
    deeppcbExportError: "deeppcb_export_error",
    // SLOW DOWN BEFORE YOU ADD STUFF HERE...THINK HARD! DOES IT REALLY, REALLY BELONG HERE?
};
//# sourceMappingURL=SurfaceBasedTrackingEvents.js.map